<script>
	import {socket} from '@sock/io'
	import {open, close, connected, server} from '@sock/connection'
	import {env} from '@lib'
	import {vmixHost, vmixPort} from '@store/query'

	function connect() {
		if (!$vmixHost || !$vmixPort)
			return alert('Lauki obligāti jāaizpilda')

		open({host: $vmixHost, port: $vmixPort})
	}
</script>

{#if $connected}
<h2>Connected to {$server}</h2>
<button on:click={close}>
	Close connection
</button>
{:else}
	<form on:submit|preventDefault={connect}>
		<input
			required
			bind:value={$vmixHost}
			name=host
			placeholder=host >
		<input
			required
			bind:value={$vmixPort}
			name=port
			placeholder=port >

		<button>
			Open connection
		</button>
	</form>
{/if}

<style>
	form {
		width: 100%;
	}

	input {
		width: 100%;
		margin-bottom: var(--spacing-sm);
	}
</style>
